"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.find");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Form = _interopRequireDefault(require("@icare/forms/lib/models/Form"));

var _FormBuilder = _interopRequireDefault(require("@icare/forms/lib/components/FormBuilder"));

var _Button = _interopRequireDefault(require("@icare/components/lib/Button"));

var _Spinner = _interopRequireDefault(require("@icare/components/lib/Spinner"));

var _Message = _interopRequireDefault(require("@icare/components/lib/Message"));

var _IdentityService = _interopRequireDefault(require("../services/IdentityService"));

var _IdentityUtils = _interopRequireDefault(require("../utils/IdentityUtils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var formConfig = {
  id: "changePasswordForm",
  sections: [{
    id: "changePasswordForm",
    fields: [{
      id: "OldPassword",
      type: "password",
      required: true,
      requiredMessage: "Please enter your old password"
    }, {
      id: "NewPassword",
      type: "password",
      required: true,
      requiredMessage: "Please enter your new password",
      validators: [{
        type: "isPassword",
        data: {
          message: "Your password doesn\u2019t meet the requirements above. Please try again."
        }
      }, {
        type: "isLength",
        data: {
          message: "Your new password has too many characters, please ensure your new password is less than {max} characters",
          options: {
            max: 100
          }
        }
      }]
    }, {
      id: "VerifyPassword",
      type: "password",
      required: true,
      requiredMessage: "Please re-type your new password",
      validators: [{
        type: "isMatch",
        data: {
          sectionId: "changePasswordForm",
          fieldId: "NewPassword",
          message: "Sorry, your passwords do not match. Please try again."
        }
      }]
    }]
  }]
};

var ChangePassword = /*#__PURE__*/function (_React$Component) {
  _inherits(ChangePassword, _React$Component);

  var _super = _createSuper(ChangePassword);

  //region Properties
  //endregion
  //region Lifecycle
  function ChangePassword(props) {
    var _this;

    _classCallCheck(this, ChangePassword);

    _this = _super.call(this, props);
    var formData = props.onInitilise(formConfig); //check overrides for messages before initializing the form

    if (props.requiredMessageNewPassword) {
      var fieldNewPassword = formData.sections.find(function (section) {
        return section.id === 'changePasswordForm';
      }).fields.find(function (field) {
        return field.id === 'NewPassword';
      });

      if (fieldNewPassword) {
        fieldNewPassword.requiredMessage = props.requiredMessageNewPassword;
      }
    }

    if (props.requiredMessageVerifyPassword) {
      var fieldRetypePassword = formData.sections.find(function (section) {
        return section.id === 'changePasswordForm';
      }).fields.find(function (field) {
        return field.id === 'VerifyPassword';
      });

      if (fieldRetypePassword) {
        fieldRetypePassword.requiredMessage = props.requiredMessageVerifyPassword;
      }
    }

    if (props.requiredMessageOldPassword) {
      var fieldOldPassword = formData.sections.find(function (section) {
        return section.id === 'changePasswordForm';
      }).fields.find(function (field) {
        return field.id === 'OldPassword';
      });

      if (fieldOldPassword) {
        fieldOldPassword.requiredMessage = props.requiredMessageOldPassword;
      }
    }

    _this.state = {
      form: _Form.default.initialiseFromConfig(formData),
      isBusy: false,
      successfulChange: false
    };
    _this._service = new _IdentityService.default(props.identityBaseUrl, props.auth);
    _this._handleSubmit = _this._handleSubmit.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ChangePassword, [{
    key: "getErrorDetails",
    value: function getErrorDetails(errors) {
      this.setState({
        isBusy: false,
        message: _IdentityUtils.default.getErrorDetails(errors)
      });
    } //endregion
    //region Methods

  }, {
    key: "_handleSubmit",
    value: function () {
      var _handleSubmit2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
        var _this$props, confirmationTitle, confirmationMessage, form, response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, confirmationTitle = _this$props.confirmationTitle, confirmationMessage = _this$props.confirmationMessage;
                form = this.state.form;
                this.setState({
                  isBusy: true
                });
                _context.prev = 3;
                _context.next = 6;
                return this._service.changePassword(values.changePasswordForm__OldPassword, values.changePasswordForm__NewPassword);

              case 6:
                response = _context.sent;

                if (!(response.errors && response.errors.length)) {
                  _context.next = 9;
                  break;
                }

                throw new Error({
                  innerErrors: response.errors
                });

              case 9:
                this.setState({
                  message: {
                    type: _Message.default.type.SUCCESS,
                    title: confirmationTitle,
                    body: /*#__PURE__*/_react.default.createElement("span", {
                      dangerouslySetInnerHTML: {
                        __html: confirmationMessage
                      }
                    })
                  },
                  isBusy: false,
                  successfulChange: true
                }, function () {
                  form.fields.get('changePasswordForm__OldPassword').set('disabled', true);
                  form.fields.get('changePasswordForm__NewPassword').set('disabled', true);
                  form.fields.get('changePasswordForm__VerifyPassword').set('disabled', true);
                });
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](3);

                if (_context.t0.name !== 'APIError') {
                  console.error(_context.t0);
                }

                this.setState({
                  isBusy: false,
                  message: _IdentityUtils.default.getErrorDetails(_context.t0.innerErrors)
                });

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 12]]);
      }));

      function _handleSubmit(_x) {
        return _handleSubmit2.apply(this, arguments);
      }

      return _handleSubmit;
    }() //endregion
    //region Renders

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          additionalButtons = _this$props2.additionalButtons,
          submitButtonText = _this$props2.submitButtonText;
      var _this$state = this.state,
          message = _this$state.message,
          successfulChange = _this$state.successfulChange,
          isBusy = _this$state.isBusy,
          form = _this$state.form;
      var buttons = [additionalButtons, /*#__PURE__*/_react.default.createElement(_Button.default, {
        key: "btnSubmit",
        type: "submit",
        disabled: isBusy
      }, submitButtonText)];
      return /*#__PURE__*/_react.default.createElement(_Spinner.default, {
        active: isBusy
      }, /*#__PURE__*/_react.default.createElement(_FormBuilder.default, {
        formStore: form,
        buttons: !successfulChange && buttons,
        onSubmit: this._handleSubmit
      }), message && /*#__PURE__*/_react.default.createElement(_Message.default, {
        type: message.type,
        title: message.title
      }, message.body));
    } //endregion

  }]);

  return ChangePassword;
}(_react.default.Component);

exports.default = ChangePassword;

_defineProperty(ChangePassword, "propTypes", {
  auth: _propTypes.default.object.isRequired,
  identityBaseUrl: _propTypes.default.string.isRequired,
  onInitilise: _propTypes.default.func,
  additionalButtons: _propTypes.default.node,
  submitButtonText: _propTypes.default.string,
  confirmationTitle: _propTypes.default.string,
  confirmationMessage: _propTypes.default.string,
  requiredMessageNewPassword: _propTypes.default.string,
  requiredMessageVerifyPassword: _propTypes.default.string,
  requiredMessageOldPassword: _propTypes.default.string
});

_defineProperty(ChangePassword, "defaultProps", {
  onInitilise: function onInitilise(config) {
    return config;
  },
  additionalButtons: null,
  submitButtonText: 'Update',
  confirmationTitle: 'Password Updated',
  confirmationMessage: 'Your password has been updated successfully',
  requiredMessageNewPassword: '',
  requiredMessageVerifyPassword: '',
  requiredMessageOldPassword: ''
});
//# sourceMappingURL=ChangePasswordForm.js.map